// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"a5bd1da4","527":"55304c38","910":"c09ba5d7","967":"895b75d4"}[chunkId] + ".chunk.js";
};